export default __webpack_public_path__ + "static/media/chevron.8667aa35.svg";